'use client';
import { Cart, CartAttribute } from '@/lib/shopify';
import { ReactNode, createContext, useContext } from 'react';
import useSWR from 'swr';

interface CartContextValue {
  cart: Cart | null;
}

const CartContext = createContext({} as CartContextValue);

interface CartProviderProps {
  children: ReactNode;
  value?: CartContextValue;
}

export const CartContextProvider: React.FC<CartProviderProps> = ({
  children,
}) => {
  const fetcher = () =>
    fetch('/api/cart', { cache: 'no-cache' }).then((res) => res.json());
  const { data } = useSWR('/cart', fetcher);

  const cartContextValue = {
    cart: data,
  };

  return (
    <CartContext.Provider value={cartContextValue}>
      {children}
    </CartContext.Provider>
  );
};

const useCartContext = () => {
  const context = useContext(CartContext);

  if (!context) {
    throw new Error('useCartContext must be used within a CartContextProvider');
  }

  return context;
};

export default useCartContext;
